import { render, staticRenderFns } from "./ConfirmModal.vue?vue&type=template&id=48639d0c&scoped=true&"
import script from "./ConfirmModal.vue?vue&type=script&lang=js&"
export * from "./ConfirmModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48639d0c",
  null
  
)

component.options.__file = "ConfirmModal.vue"
export default component.exports